import ScenarioConfigContext from "Context/ScenarioConfigContext";
import UserContext from "Context/UserProvider";
import {
  useContext,
  useEffect,
  useState
} from "react";
import { Outlet } from "react-router";
import { useApiService } from "../services/ApiService/ApiService";
import { Box, CircularProgress } from '@mui/material';
import toast from 'react-hot-toast';

const ScenarioContextProvider = (props: any) => {
  const [scenarioConfigInfo, setScenarioConfigInfo] = useState({
    runningScenario: {} as any,
    draftScenario: {} as any,
  });
  const [loading, setLoading] = useState(true);
  const { userInfo } = useContext(UserContext);
  const { fetchWithAuth } = useApiService();

  async function fetchDraft() {
    try {
      const response = await fetchWithAuth('/DragDrop/fleet/scenario/draft', {
        method: 'POST',
        body: JSON.stringify({
          uuid: userInfo.uuid,
          fleetUuid: userInfo.fleetUuid
        })
      });

      if (!response.ok) {
        throw new Error('Failed to fetch scenario draft');
      }

      const res_json = await response.json();
      console.log("res_json", res_json);  

      console.log("res_json.draftScenario", res_json.draftScenario);
      console.log("res_json.runningScenario", res_json.runningScenario);

      setScenarioConfigInfo(prev => ({
        ...prev,
        draftScenario: res_json.draftScenario,
        runningScenario: res_json.runningScenario
      }));
    } catch (error) {
      console.error('Error fetching scenario draft:', error);
      toast.error('Failed to fetch scenario draft');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchDraft();
  }, []);

  return (
    <ScenarioConfigContext.Provider
      value={[scenarioConfigInfo, setScenarioConfigInfo]}
    >
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
          <CircularProgress />
        </Box>
      ) : (
        <Outlet />
      )}
    </ScenarioConfigContext.Provider>
  );
};

export default ScenarioContextProvider;
